(function($) {
    $(document).ready(function() {
        $('#Form_CouponPrizeForm').on('submit', function(e) {
            e.preventDefault();

            var $this = $(this),
                formWrapper = $('.coupon-form'),
                errorEl = formWrapper.find('.error'),
                couponResultSpinner = $('.coupon-result-spinner'),
                couponResult = $('.coupon-result'),
                couponBoxH3 = $('.coupon-box > h3'),
                startMsTimeStamp = Date.now();

            errorEl.hide();
            $this.hide();
            var imageGif = $('<img src="/resources/themes/base/production/images/coupon-animated-spinner.gif" />');
            couponResultSpinner.html(imageGif).show();
            couponBoxH3.text(couponBoxH3.data('alt-text'));
            $.ajax({
                url: $this.attr('action'),
                method: 'POST',
                data: $this.serialize(),
                dataType: 'json',
                cache: false
            }).done(function(data) {
                if (data.status === 1) {
                    var endMsTimeStamp = Date.now(),
                        msTimeStampDiff = endMsTimeStamp - startMsTimeStamp,
                        timeoutMs = (2000 - msTimeStampDiff);
                    if (timeoutMs > 0) {
                        setTimeout(displayResult, timeoutMs, couponResult, couponResultSpinner, errorEl, data);
                    } else {
                        displayResult(couponResult, couponResultSpinner, errorEl, data);
                    }
                    if (data.error == '') { // only if it's their first time. If it's not their first time then there will be an error.
                        $.get('https://hooks.zapier.com/hooks/catch/1160516/bblwzgy', { email: $('#Form_CouponPrizeForm_Email').val(), coupon: data.coupon.CouponCode });
                    }
                } else if (data.error != '') {
                    couponResultSpinner.hide();
                    $this.show();
                    errorEl.text(data.error).show();
                }
            });
        });

        function displayResult(couponResultEl, couponResultSpinnerEl, errorEl, data) {
            couponResultSpinnerEl.hide();
            couponResultEl.show();
            couponResultEl.find('h3').text(data.coupon.Text);
            couponResultEl.find('.coupon-code').text(data.coupon.CouponCode);
            couponResultEl.find('.coupon-code-link').attr('href', data.coupon.ButtonURL).text(data.coupon.ButtonText);
            if (data.error != '') {
                errorEl.text(data.error).show();
            }
        }
    });
})(jQuery);



// WEBPACK FOOTER //
// ./js/modules/couponPrizePage.js